import { justForYou } from 'assets';
import Image from 'next/image';
import React from 'react';

const JustForYou = () => {
  return (
    <div className='w-full h-full bg-dropDownMenuBg rounded-3xl p-6 flex-col flex gap-6 justify-between '>
      <Image
        className='w-full  '
        alt='trackImage'
        width={340}
        height={140}
        src={justForYou}
      />
      <div className='flex flex-col gap-2'>
        <p className='text-lg leading-[26px] font-semibold text-white text-start'>
          Made Just for You
        </p>
        <p className='text-sm font-normal leading-[22px] text-grayZl-600 text-start'>
          Every tap feels right. ZebraLearn adapts to how you think.
        </p>
      </div>
    </div>
  );
};

export default JustForYou;
